import { GetEditCampaignsReportsConfigParams } from './campaigns.types';

export const getCampaignsReportsConfig = ({
    customerType,
    customerId,
    conversionType,
    isNewOverview,
    startDate,
    endDate,
}, is_short_report = true) => ({
    url: `/api/${customerType}/${customerId}/campaigns/stats/`,
    method: 'GET',
    params: {
        end_date: endDate,
        is_new_overview: isNewOverview,
        start_date: startDate,
        conversion_type: conversionType,
        is_short_report,
    },
});

export const getEditCampaignsReportsConfig = ({
    accountId,
    platform,
    level,
    campaignId,
    subLevelId,
    field,
    fieldValue,
    budgetId,
}: GetEditCampaignsReportsConfigParams) => ({
    url: `/api/accounts/${accountId}/campaigns/${campaignId}/`,
    method: 'POST',
    data: {
        account_id: accountId,
        platform,
        level,
        campaign_id: campaignId,
        sublevel_id: subLevelId,
        field_updated: field,
        [field]: fieldValue,
        budget_id: budgetId,
    },
});
